import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import Helmet from 'react-helmet';
import OrderStore from '../../stores/OrderStore';
import OrdersList from '../../components/OrdersList';
import Breadcrumbs from '../../components/Breadcrumbs';
import styles from './index.sass';

class OrderHistoryContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store) {
    let title = `Order history – ${store.name}`;
    return {
      title: title,
      meta: []
    };
  }

  render() {
    let { ordersState, store } = this.props;
    let ordersListProps = {
      ...ordersState,
      loading: ordersState.loading || !this.props.isNavigateComplete,
      store: store
    };
    let breadcrumbsProps = {
      links: [
        {routeName: 'storeLandingPage'}
      ]
    };
    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <h1>Order history</h1>
        <OrdersList {...ordersListProps} />
      </section>
    );
  }
}

OrderHistoryContainer = connectToStores(OrderHistoryContainer, [OrderStore], (context, props) => {
  return {
    ordersState: context.getStore(OrderStore).getCurrentState()
  };
});

export default OrderHistoryContainer;



// WEBPACK FOOTER //
// banquet/containers/OrderHistoryContainer/index.js